<template>
  <div>
    <WsDialog
      v-model="dialog"
      ref="WsDialog"
      @close="$_handleDialogClose()"
      :title="title"
    >
      <template v-slot:content>
        <div
          v-if="isLoading"
          class="loading-section"
        >
          <v-progress-circular
            size="20"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>
        <WsSortList
          v-else
          :value="state"
          :textKey="textKey"
          :errorMessages="errorMessages"
          @sortList="$_updateList($event)"
        ></WsSortList>
      </template>
      <template v-slot:rightActions>
        <WsBtn
          @click="$_onCancel()"
          minWidth="100px"
          color="textSecondary"
          outlined
        >取消</WsBtn>
        <WsBtn
          @click="$_onSubmit()"
          minWidth="100px"
          :loading="submitLoading"
          color="primary"
        >送出</WsBtn>
      </template>
    </WsDialog>
  </div>
</template>
<script>
import S_multiLayer from "@/helpers/multiLayer";
export default {
  data: () => ({
    submitLoading: false,
    dialog: false,
    state: [],
    isLoading: false,
  }),
  props: {
    modelName: {
      type: String,
    },
    getLayersKey: {
      type: String,
    },
    getUrl: {
      type: String,
    },
    title: {
      type: String,
      default: "",
    },
    errorMessages: {
      type: Array,
      default() {
        return [];
      },
    },
    textKey: {
      type: String,
      default: 'name',
    },
    valueKey: {
      type: String,
      default: 'id',
    },
    parentModelName: {
      type: String,
    },
    parentId: {
      type: [String, Number],
    },
    isOnlyOutputItemLayers: {
      type: Boolean,
      default: true,
    },
    setLayersKey: {
      type: String,
    },
    paramsKey: {
      type: String,
    }
  },
  methods: {
    async $_fetchData() {
      try {
        this.isLoading = true
        let url = `${this.modelName}/${this.$route.params.id}`;
        if (this.parentModelName && this.parentId) url = `${this.parentModelName}/${this.parentId}/${this.modelName}`;
        const params = {order_by: 'sequence', order_way: 'asc'};
        const res = await this.$axios.get(url, {params});
        this.state = this.$_setState(res.data.data)
        this.isLoading = false
      } catch (error) {
        alert(error)
      }
    },
    $_handleDialogClose() {
      window.removeEventListener("keydown", this.$_keydownHandler);
    },
    async $_keydownHandler(event) {
      if (event.metaKey && event.key === "Enter") {
        await this.$_onSubmit();
      }
    },
    async $_onSubmit() {
      const keys = {
        valueKey: this.valueKey,
        textKey: this.textKey,
        getLayersKey: 'layers',
        setLayersKey: this.setLayersKey
          ? this.setLayersKey
          : this.getLayersKey
          ? this.getLayersKey
          : this.modelName,
      };
      const result = S_multiLayer.setItems(this.state, keys)
      try {
        const paramsKey = this.paramsKey
          ? this.paramsKey
          : this.getLayersKey
          ? this.getLayersKey
          : this.modelName;
        await this.$axios.post(this.getUrl, {[`${paramsKey}`]: result});
        this.$emit("updateSort");
        this.close();
      } catch (error) {
        alert(error)
      }
    },
    $_onCancel() {
      this.close();
    },
    close() {
      this.dialog = false;
      window.removeEventListener("keydown", this.$_keydownHandler);
    },
    open() {
      this.dialog = true;
      this.$_fetchData();
    },
    $_updateList($event) {
      this.state = $event;
    },
    $_setState(data) {
      const keys = {
        valueKey: this.valueKey,
        textKey: this.textKey,
        getLayersKey: this.getLayersKey ? this.getLayersKey : this.modelName,
        setLayersKey: 'layers',
      }
      const layers = S_multiLayer.setItems(data, keys, this.isOnlyOutputItemLayers);
      return layers
    },
  },
};
</script>
